import React, { useEffect, useState } from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import { useNavigate } from 'react-router-dom';
import { Get_Api } from '../Api_Url';
import ContentLoader from 'react-content-loader';
import GetSeodata from '../Components/GetSeodata';

function CountryList() {
    const navigate = useNavigate();
    const [allDestinations, setAllDestinations] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const getAllDestinations = async () => {
        try {
            setIsLoading(true);
            const response = await Get_Api(`api/admin/GetAllCountry`);
            setAllDestinations(response?.data);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.error(error);
        }
    };

    useEffect(() => {
        getAllDestinations();
    }, []);

    const handleViewMore = (name, id) => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        navigate(`/destination/${name}`, { state: { id } });
      };

    return (
        <>
            <Navbar />
            <GetSeodata PageName={'country'} />
            <div className='about-div'>
                <h1>Country</h1>
                <p><i>Home - Country</i></p>
            </div>
            <div className='Destination-div'>
                {isLoading ? (
                    <ContentLoader viewBox="0 0 820 450" height={'100%'} width={'100%'} >
                        <rect x="10" y="10" rx="5" ry="5" width="260" height="140" />
                        <rect x="280" y="10" rx="5" ry="5" width="260" height="280" />
                        <rect x="550" y="10" rx="5" ry="5" width="260" height="140" />
                        <rect x="10" y="160" rx="5" ry="5" width="260" height="280" />
                        <rect x="280" y="300" rx="5" ry="5" width="260" height="140" />
                        <rect x="550" y="160" rx="5" ry="5" width="260" height="280" />
                    </ContentLoader>
                ) : (
                    allDestinations?.map((destination) => (
                        <div className='Destination-card' key={destination._id}
                            style={{ backgroundImage: `url(${destination.Image})`, }} >
                            <div className='Destination-heading'>
                                <div>
                                    <h4><i>{destination.Name}</i></h4>
                                </div>
                                <button onClick={() => handleViewMore(destination.Name, destination._id)} className='view-more-button'>
                                    View More
                                </button>
                            </div>
                        </div>
                    ))
                )}
            </div>
            <Footer />
        </>
    );
}

export default CountryList;